import { useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'
import { getTotalApiV1NotificationsFeedUserEventTotalGetQueryKey } from '../gen/base'

export const useInvalidateNotificationsFeedUserEventTotal = () => {
    const queryClient = useQueryClient()

    return useCallback(() => {
        queryClient.invalidateQueries({
            queryKey: getTotalApiV1NotificationsFeedUserEventTotalGetQueryKey(),
        })
    }, [queryClient])
}
